import React, { useState } from 'react'
import { Accordion, Card, Button } from 'react-bootstrap'

const Index = () => {

    const [activeTab, setActiveTab] = useState("0")

    return(
        <div className="tab-section-container">
            <div className="inner-tab-section-container">
                <p className="introduction-text">
                    Lister er et verktøy som gir deg muligheten til å finne absolutt alle registrerte virksomheter i hele norge, men samtidig kun de som er relevant for deg. Lag lister på opp til 10 000 foretak, og filtrer på alt fra bransje og område, til organisasjonstype, stiftelsesdato og mer.
                    <br/><br/>
                    Gjennom listene du lager får du umiddelbar tilgang på bedriftsinformasjon, og er ett klikk unna både å ringe til bedriften eller sende dem en e-post, gitt at de har gjort denne informasjonen tilgjengelig. Herfra kan du også legge til bedriften som kunde eller kontakt i en av dine eksisterende kontaktlister. 
                </p>
                <div className="accordion-container">
                <Accordion className="company-accordion" defaultActiveKey="0" activeKey={activeTab}>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="0" onClick={() => setActiveTab("0")}>
							<button className={`collapse-button ${activeTab === "0" ? "active":""}`}>{activeTab === "0" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Opprett en liste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="0">
						<Card.Body className="card-body">
							<p className="description-text">Du kan enkelt opprette en ny liste med bedrifter slik:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Lister"</span> fra menyen til venstre.</li>
								<li>Trykk på <span className="bold">"Ny liste"</span>-knappen oppe til høyre hjørne.</li>
							</ol>
							<p className="description-text">På siden du nå er kommet til kan du benytte deg av fanene øverst for å gjøre ulik filtrering.</p>
							<h5 className="description-subtitle">Filtrere på næring</h5>
							<p className="description-text">For å filtrere bedrifter på bransje kan du trykke på <span className="bold">"Næring"</span>-fanen øverst på siden. Her vil du få opp alle bransjene som finnes i Norge, og du kan huke av hvilke du ønsker. Når du har valgt, vil alle underkategorier av bransjen bli synlig som du også kan velge, og slik går det ned fem nivåer.</p>
							<h5 className="description-subtitle">Filtrere på sted</h5>
							<p className="description-text">Du kan også filtrere listen din på områder og hvor du vil at bedriftene skal holde til. Du kan gjøre dette under <span className="bold">"Sted"</span>-fanen, hvor du kan huke av alle kommuner du ønsker.</p>
							<h5 className="description-subtitle">Filtrering på organisasjon</h5>
							<p className="description-text">Dersom du ønsker å gjøre enda mer bedriftsspesifikk filtrering, kan du gjøre dette under <span className="bold">"Organisasjon"</span>-fanen. Her kan du filtrere på antall ansatte, organisasjonstype, stiftelsesdato og mer.</p>
							<h5 className="description-subtitle">Fullfør opprettelse</h5>
							<p className="description-text">Etter du har gjort all nødvendig filtrering, skriv inn navnet på listen din i feltet til høyre og trykk  på <span className="bold">"Opprett liste"</span>-knappen. Du vil nå bli tatt tilbake til oversikten over alle listene du har, og kan nå klikke deg inn på listen du lagde for å se alle bedrifter.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="1" onClick={() => setActiveTab("1")}>
                            <button className={`collapse-button ${activeTab === "1" ? "active":""}`}>{activeTab === "1" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Endre en liste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="1">
						<Card.Body className="card-body">
                            <p className="description-text">Det er kun mulig å endre navnet på en liste du tidligere har opprettet, og slik gjør du det:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Lister"</span> fra menyen til venstre.</li>
								<li>Trykk på penn-ikonet i samme rad som listenavnet du ønsker å endre.</li>
								<li>Erstatt navnet som står i tekstfeltet med ditt nye navn.</li>
								<li>Trykk deretter på <span className="bold">"Oppdater"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="2" onClick={() => setActiveTab("2")}>
                            <button className={`collapse-button ${activeTab === "2" ? "active":""}`}>{activeTab === "2" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Slett en liste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="2">
						<Card.Body className="card-body">
							<p className="description-text">Prosessen med å slette en liste er rask og enkel, og slik går du frem for å gjøre det:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Lister"</span> fra menyen til venstre.</li>
								<li>Trykk på søppeldunk-ikonet i samme rad som listen du ønsker å slette.</li>
								<li>Trykk på <span className="bold">"Ja, slett listen"</span>-knappen i popupen som vises.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
				    <Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="3" onClick={() => setActiveTab("3")}>
                            <button className={`collapse-button ${activeTab === "3" ? "active":""}`}>{activeTab === "3" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Vis bedriftsinformasjon
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="3">
						<Card.Body className="card-body">
                            <p className="description-text">Etter du har opprettet en liste vil du få mulighet til å hente ut og se på informasjonen til alle bedriftene i listen din nærmest umiddelbart, og slik går du frem:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Lister"</span> fra menyen til venstre.</li>
								<li>Trykk på en liste du har opprettet tidligere.</li>
							</ol>
							<p className="description-text">Siden du nå kommer til er en oversikt over alle bedriftene i listen du opprettet tidligere, med selve bedriftslisten på venstre side og presentasjonen på høyre side.</p>
							<h5 className="description-subtitle">Navigering</h5>
							<p className="description-text">Du kan enkelt navigere deg gjennom bedrifter enten ved å trykke på bedriftene vist i listen til venstre, eller bruke opp/ned-piltastene. Du får presentert 25 bedrifter om gangen i oversikten til venstre, og kan enkelt laste inn flere ved å trykke <span className="bold">"Hent flere virksomheter"</span> i bunn.</p>
							<h5 className="description-subtitle">Presentasjon</h5>
							<p className="description-text">
								På høyre del av siden vil all informasjon om bedriften vises. Knapp for å ringe og sende e-post vil alltid være øverst, og hvis informasjonen er tilgjengelig kan du trykke på den for å umiddelbart sende en e-post eller ringe. Du kan bruke fanene under for å vise ulike typer informasjon om bedriften.
								<br/><br/>
								Under <span className="bold">"Detaljer"</span> finner du generell bedriftsinformasjon og kontaktinformasjon, med linker til både hjemmeside og SoMe-kanaler. Du kan se alle rollene i selskapet under <span className="bold">"Roller"</span>-fanen, med mulighet til å gjøre direkte oppslag i både telefonkatalog og på LinkedIn.
								<br/><br/>
								Du kan se alle aksjonærer i selskapet under <span className="bold">"Aksjonærer"</span>-fanen, inkludert en oversikt over eierandeler vist i prosent. Under <span className="bold">"Notater"</span>-fanen kan du legge til notater på bedriften du skal heller har vært i dialog med, og som kan være nyttig for deg selv eller andre du måtte jobbe med.
							</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="4" onClick={() => setActiveTab("4")}>
                            <button className={`collapse-button ${activeTab === "4" ? "active":""}`}>{activeTab === "4" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til responser
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="4">
						<Card.Body className="card-body">
                            <p className="description-text">Når du er i prosessen med å kontakte nye potensielle kunder er det nyttig å oppdatere ulike bedrifters respons, og dette kan du gjøre raskt og enkelt slik:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Velg respons"</span>-knappen øverst på høyre del av siden.</li>
								<li>Velg responsen bedriften ga deg.</li>
							</ol>
							<p className="description-text">Responsen vil da umiddelbart oppdatere seg, og bli vist i listevisningen på venstre side. Dersom du har lagt til feil respons kan du fjerne denne ved å velge <span className="bold">"Fjern respons"</span> nederst fra menyen.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="5" onClick={() => setActiveTab("5")}>
                            <button className={`collapse-button ${activeTab === "5" ? "active":""}`}>{activeTab === "5" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Fjern bedrift fra liste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="5">
						<Card.Body className="card-body">
                            <p className="description-text">Dersom du av en eller annen grunn ønsker å fjerne en bedrift fra listevisningen på venstre side kan du trykke på søppelbøtte-ikonet til høyre for bedriftsnavnet.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="6" onClick={() => setActiveTab("6")}>
                            <button className={`collapse-button ${activeTab === "6" ? "active":""}`}>{activeTab === "6" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til notat
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="6">
						<Card.Body className="card-body">
                            <p className="description-text">For å legge til et notat på en valgt bedrift, gjør dette:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Notater"</span>-fanen på øvre del av høyre side.</li>
								<li>Trykk på tekstfeltet og skriv inn notatet.</li>
								<li>Trykk så på <span className="bold">Enter</span>-knappen, og notatet vil bli publisert.</li>
							</ol>
							<p className="description-text">Alle notatene som er lagt inn på denne bedriften vil da vises her, også fra andre som har tilgang til miljøet. Du vil da se hvem som har skrevet notatet, innholdet og dato.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="7" onClick={() => setActiveTab("7")}>
                            <button className={`collapse-button ${activeTab === "7" ? "active":""}`}>{activeTab === "7" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Fjern et notat
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="7">
						<Card.Body className="card-body">
                            <p className="description-text">Prosessen for å slette et notat på en valgt bedrift er enkel, og du gjør det på denne måten:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Notater"</span>-fanen på øvre del av høyre side.</li>
								<li>Trykk på søppelbøtte-ikonet på høyre side av notatet.</li>
							</ol>
							<p className="description-text">Notatet vil da bli slettet og notatlisten oppdatert.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="8" onClick={() => setActiveTab("8")}>
                            <button className={`collapse-button ${activeTab === "8" ? "active":""}`}>{activeTab === "8" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til som kunde
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="8">
						<Card.Body className="card-body">
                            <p className="description-text">Dersom du ønsker å legge til valgt bedrift i listen din som kunde, gå frem slik:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Legg til som"</span>-knappen på øvre del av høyre side.</li>
								<li>Velg <span className="bold">"Ny kunde"</span> fra menyen som vises.</li>
							</ol>
							<p className="description-text">Bedriften vil da automatisk bli lagt til som kunde med korrekt bedriftsinformasjon.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="9" onClick={() => setActiveTab("9")}>
                            <button className={`collapse-button ${activeTab === "9" ? "active":""}`}>{activeTab === "9" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Fjern som kunde
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="9">
						<Card.Body className="card-body">
                            <p className="description-text">For å fjerne en bedrift som kunde gjennom listevisningen, gjør dette:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Legg til som"</span>-knappen på øvre del av høyre side.</li>
								<li>Velg <span className="bold">"Ny kunde"</span> fra menyen som nå vises som aktiv.</li>
							</ol>
							<p className="description-text">Bedriften vil da umiddelbart bli slettet som bedriftskunde. Blå bakgrunn med en hake på <span className="bold">"Ny kunde"</span>-valget er en indikasjon på at bedriften eksisterer som bedriftskunde.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card last">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="10" onClick={() => setActiveTab("10")}>
                            <button className={`collapse-button ${activeTab === "10" ? "active":""}`}>{activeTab === "10" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Legg til i kontaktliste
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="10">
						<Card.Body className="card-body">
                            <p className="description-text">Hvis du ønsker å legge til valgt bedrift i en kontaktliste gjør du følgende:</p>
							<ol className="description-list">
								<li>Trykk på <span className="bold">"Legg til som"</span>-knappen på øvre del av høyre side.</li>
								<li>Velg <span className="bold">"Kontakt i kontaktliste"</span> fra menyen som nå vises som aktiv.</li>
								<li>Velg riktig kontaktliste i skjemaet som kommer opp.</li>
								<li>Sjekk at detaljene er korrekte ved å trykke på de ulike underkategoriene.</li>
								<li>Trykk på <span className="bold">"Legg til"</span>-knappen.</li>
							</ol>
							<p className="description-text">Kontaktinformasjonen som vil bli foreslått er styrets/daglig leder sitt navn med kontaktinformasjonen til bedriften. Dette er for å minske sjansen om at det ikke hentes en personlig e-post, som hindrer deg gjennom markedsføringsloven å sende e-post til uten samtykke.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
                </div>
            </div>
        </div>
    )
}

export default Index
